var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCa = function SvgCa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F8FB",
    d: "M0 0h16v12H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E31D1C",
    d: "M4 0v12H0V0zM16 0v12h-4V0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DC251C",
    d: "M6.91 4.024 8 2.5l1.09 1.524v1.298l1.91.216L9.636 7.27l-1.09.433-.355 1.167a.2.2 0 0 1-.382 0l-.354-1.167-1.091-.433L5 5.54l1.91-.217V4.024Z"
  })));
};
export default SvgCa;